import React from "react";
import { RiSearchLine } from "react-icons/ri";

interface SearchDialogBoxProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  width?: string;
  smWidth?: string;
}

const SearchDialogBox: React.FC<SearchDialogBoxProps> = ({
  value,
  onChange,
  placeholder,
  width = "283px",
}) => {
  return (
    <div
      className="flex items-center border border-grey-300 dark:border-grey-600 rounded bg-white dark:bg-blue-900 px-3"
      style={{
        width: width,
        height: "40px",
        overflow: "visible",        
        alignItems: "center",       
      }}
    >
      <RiSearchLine
        className="text-gray-800 dark:text-grey-100"
        style={{
          fontSize: "24px",          
          flexShrink: 0,             
        }}
      />

      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="
          ml-2 w-full bg-transparent outline-none
          text-grey-800 dark:text-gray-200
          font-inter font-normal text-[14px] leading-[16px] tracking-[0px]
          placeholder:font-inter placeholder:font-normal placeholder:text-[14px]
          placeholder:leading-[16px] placeholder:tracking-[0px]
          placeholder:text-grey-500 dark:placeholder:text-grey-400
        "
        style={{ lineHeight: 'normal' }}
      />
    </div>
  );
};

export default SearchDialogBox;
